import KeyPlayerStackMarker from './key-player-stack-marker';
import Const from 'constants';
import {Storage} from 'storages/storage';

class KeyPlayerStackAnalyzer {
    constructor(params) {
        const {players, stacking, simplexLineup} = params;

        this._players = players;
        this._stacking = stacking;
        this._simplexLineup = simplexLineup;

        this._stackItemIds = this._getStackItemIds();
        this._mappedStackedPlayers = this._mapStackedPlayers();
    }

    _getStackItemIds() {
        const simplexUnitIds = this._simplexLineup.getRaw(Const.LP_KEY_UNIT_PREFIX);
        return KeyPlayerStackMarker.pickMarkedBySuffix(simplexUnitIds);
    }

    _mapStackedPlayers() {
        const lineupUnitIds = this._simplexLineup.getDistilled(Const.LP_UNIT_PREFIX);
        const stackedPlayers = {};
        const teamsOfKeyPlayers = new Storage();
        this._stackItemIds.map((itemId) => {
            if (!this._stacking.hasOwnProperty(itemId)) {
                return;
            }

            const {stackItemId, keys} = this._stacking[itemId];
            const [keyPlayerId] = keys;
            const {team} = this._players.getPlayer(keyPlayerId);

            if (inArray(team, teamsOfKeyPlayers.get(stackItemId, []))) {
                return;
            }

            teamsOfKeyPlayers.patchArr(stackItemId, team);

            if (!stackedPlayers.hasOwnProperty(keyPlayerId)) {
                stackedPlayers[keyPlayerId] = new Set();
            }

            this._stacking[itemId].players.map((playerId) => {
                if (inArray(String(playerId), lineupUnitIds)) {
                    stackedPlayers[keyPlayerId].add(playerId);
                }
            });
        });

        return stackedPlayers;
    }

    getKeyPlayerIds() {
        return Object.keys(this._mappedStackedPlayers);
    }

    getStackedPlayerIdsByKeyPlayerId(playerId) {
        if (this._mappedStackedPlayers.hasOwnProperty(playerId)) {
            return [...this._mappedStackedPlayers[playerId]];
        }
        return [];
    }
}

export default KeyPlayerStackAnalyzer;
